import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { searchData } from "../../redux/filter/action";

const Search = () => {
  const dispatch = useDispatch();
  const [searchKeyword, setSearchKeyword] = useState("");

  // debounce function
  function debounce(fn, delay) {
    let timer;
    return (() => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(), delay);
    })();
  }

  const searchFunction = () => {
    dispatch(searchData(searchKeyword));
  };

  debounce(searchFunction, 2000);

  return (
    <div class="border mt-6 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200">
      <input
        className="outline-none border-none bg-gray-50 h-full w-full mr-2"
        type="search"
        name="search"
        placeholder="Search"
        values={searchKeyword}
        onChange={(e) => setSearchKeyword(e.currentTarget.value)}
      />
      <img
        className="inline h-6 cursor-pointer"
        src="https://www.freepnglogos.com/uploads/search-png/search-icon-endless-icons-33.png"
        alt="Search"
      />
    </div>
  );
};

export default Search;
